var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Diagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-diagnosis",
    d: "M13.688,2.914A2.442,2.442,0,0,0,11.3,5.409a2.388,2.388,0,1,0,4.772,0,2.442,2.442,0,0,0-2.386-2.495ZM4.212,4.727a.843.843,0,0,0-.723.425A2,2,0,0,0,2.22,6.2a2.155,2.155,0,0,0,.136,2.155l3.05,4.557a.071.071,0,0,0,0,.008v.356a4.541,4.541,0,0,0,4.431,4.633,4.541,4.541,0,0,0,4.431-4.633V12.029a.9.9,0,0,0,.341-.709.853.853,0,1,0-1.7,0,.9.9,0,0,0,.341.709v1.252a3.493,3.493,0,0,1-3.409,3.564,3.493,3.493,0,0,1-3.409-3.564v-.356c0-.006,0-.011,0-.017L9.289,8.3A2.134,2.134,0,0,0,9.37,6.172a2,2,0,0,0-.979-.93.849.849,0,0,0-.77-.515.892.892,0,0,0,0,1.782.822.822,0,0,0,.524-.194,1,1,0,0,1,.327.367,1.038,1.038,0,0,1-.039,1.035L5.9,11.79,3.193,7.746A1.034,1.034,0,0,1,3.127,6.7.966.966,0,0,1,3.6,6.242a.831.831,0,0,0,.607.267.892.892,0,0,0,0-1.782Zm7,3.89A1.3,1.3,0,0,0,9.939,9.948v3.893a4.251,4.251,0,0,0,.6,2.191,2.836,2.836,0,0,0,2.021-2.751v-.955a1.63,1.63,0,0,1-.341-1.005,1.535,1.535,0,1,1,3.068,0,1.63,1.63,0,0,1-.341,1.005v.955a5.412,5.412,0,0,1-2.28,4.447,3.361,3.361,0,0,0,.75.146c.085.006.169.009.252.009a2.961,2.961,0,0,0,2.113-.858,4.468,4.468,0,0,0,1.21-3.209V9.891a1.224,1.224,0,0,0-1.186-1.247Z",
    transform: "translate(-1.994 -2.914)",
    fill: "#637eba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Diagnosis);
export default __webpack_public_path__ + "static/media/icons8-diagnosis.7520014b8716b28ca1f4b2befde8105c.svg";
export { ForwardRef as ReactComponent };